import { type MutationOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'
import type { UserRole } from '@/lib/queries/business/types'

export const updateUserMutation = {
  mutationFn: (data: { userId?: number; role?: UserRole; name?: string }) => {
    const payload = { user_id: data.userId, role: data.role, name: data.name }

    return w.post(payload, API_ENDPOINTS.business.v1.user.index).json()
  },
}

export const deleteUserMutation: MutationOptions<
  {
    deletedUserIds: number[]
    failedUserIds: number[]
  },
  unknown,
  { userIds: number[] }
> = {
  mutationFn: ({ userIds }) => w.json({ userIds }).delete(API_ENDPOINTS.business.v1.user.index).json(),
}
